import service from './axios'

// 登录接口
export const login = (data) => {
  const formData = new URLSearchParams()
  formData.append('gameId', data.gameId)
  formData.append('clientKey', data.clientKey)
  formData.append('password', data.password)
  formData.append('phone', data.phone)
  
  return service({
    url: '/invoiceOnline.php?a=login',
    method: 'post',
    data: formData
  })
}

// 获取订单列表接口
export const getOrderList = (data) => {
  const formData = new URLSearchParams()
  formData.append('gameId', data.gameId)
  formData.append('userId', data.userId)
  formData.append('page', data.page)
  formData.append('limit', data.limit)
  
  return service({
    url: '/invoiceOnline.php?a=getOrderList',
    method: 'post',
    data: formData
  })
}

// 获取开票记录接口
export const getInvoiceRecords = (params) => {
  return service({
    url: '/invoiceOnline.php?a=getInvoiceList',
    method: 'post',
    params
  })
}

// 提交开票请求接口
export const submitBilling = (data) => {
  return service({
    url: '/invoiceOnline.php?a=invoiceApply',
    method: 'post',
    data
  })
}

// 开票申请接口
export const invoiceApply = (data) => {
  const formData = new URLSearchParams()
  formData.append('gameId', data.gameId)
  formData.append('userId', data.userId)
  formData.append('order_ids', data.order_ids)
  formData.append('invoice_type', data.invoice_type)
  formData.append('invoice_title', data.invoice_title)
  formData.append('invoice_money', data.invoice_money)
  formData.append('email', data.email)
  formData.append('remark', data.remark || '')
  
  if (data.invoice_type === '0') {
    formData.append('idCard', data.idCard)
  } else if (data.invoice_type === '1') {
    formData.append('company_num', data.company_num)
    formData.append('company_address', data.company_address || '')
    formData.append('company_tel', data.company_tel || '')
    formData.append('company_bank', data.company_bank || '')
    formData.append('company_account_number', data.company_account_number || '')
  }
  
  return service({
    url: '/invoiceOnline.php?a=invoiceApply',
    method: 'post',
    data: formData
  })
}

// 获取开票记录列表接口
export const getInvoiceList = (data) => {
  const formData = new URLSearchParams()
  formData.append('gameId', data.gameId)
  formData.append('userId', data.userId)
  formData.append('page', data.page)
  formData.append('limit', data.limit)
  
  return service({
    url: '/invoiceOnline.php?a=getInvoiceList',
    method: 'post',
    data: formData
  })
}
